import { useEffect, useState } from 'react';
import { projectService, Project } from '../../services/project.service';

interface ProjectPickerProps {
  value: string;
  onChange: (projectId: string, project?: Project) => void;
  required?: boolean;
  placeholder?: string;
  filterStatus?: Project['status'][];
}

export function ProjectPicker({
  value,
  onChange,
  required,
  placeholder = 'Selecciona proyecto…',
  filterStatus,
}: ProjectPickerProps) {
  const [projects, setProjects] = useState<Project[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    projectService
      .getProjects()
      .then((data) => {
        const filtered = filterStatus
          ? data.filter((p) => filterStatus.includes(p.status))
          : data;
        setProjects(filtered);
      })
      .catch(() => setProjects([]))
      .finally(() => setLoading(false));
  }, [filterStatus?.join(',')]);

  return (
    <select
      required={required}
      value={value}
      onChange={(e) => {
        const id = e.target.value;
        const project = projects.find((p) => p.id === id);
        onChange(id, project);
      }}
      className="w-full px-3 py-2.5 rounded-lg border border-slate-200 text-sm focus:border-primary focus:outline-none disabled:bg-slate-50"
      disabled={loading}
    >
      <option value="">{loading ? 'Cargando…' : placeholder}</option>
      {projects.map((p) => (
        <option key={p.id} value={p.id}>
          {p.name}
        </option>
      ))}
    </select>
  );
}